// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import {sync} from 'vuex-router-sync'
import store from './store/index'
import axios from 'axios'
import moment from 'moment'
import Vue2Filters from 'vue2-filters'
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";


window.axios = require('axios');
window.moment = require('moment');
Vue.prototype.$moment = moment;
const API_BASE_URL = process.env.VUE_APP_API_URL;

if (process.env.NODE_ENV !== "development")
  window.axios.defaults.baseURL = API_BASE_URL;

window.axios.defaults.headers.common = {'Authorization': `Bearer ${store.state.authentication.token}`}
//interceptor
window.axios.interceptors.response.use(function (config) {
    return config;
}, async function (error) {
    if (error.request !== undefined) {
        //evitar hacer la solicitud cada vez que falle el login
        if (error.request.responseURL.includes('login')) {
            //para evitar llamar cuando los credenciales sean incorrectos
            return Promise.reject(error);
        }
    }

    if (error.request !== undefined && error.request.responseURL.includes('refresh') || error.request.status === 401 || error.request.status === 422 && error.config.__isRetryRequest) {
        window.localStorage.removeItem('vuex');
        window.location = '/login';
        return Promise.reject(error);
    }/* else if (error.request !== undefined && error.request.status === 401) {
        let retry = await axios.post("/api/auth/refresh", {
            refreshToken: store.state.authentication.refreshToken
        }).then(response => {
            if (response.status === 200) {
                error.__isRetryRequest = true;

                //obtenemos lo almacenado en local storage
                let vuex_storage = JSON.parse(window.localStorage.getItem('vuex'));

                //asignamos el nuevo token
                vuex_storage.authentication.token = response.data.token;

                //insertamos nuevamente los valores
                window.localStorage.setItem('vuex', JSON.stringify(vuex_storage));

                //configuramos elementos globales
                window.axios.defaults.headers.common = {'Authorization': `Bearer ${response.data.token}`};

                //modificamos la solicitud actual para reintentar
                error.config.headers['Authorization'] = `Bearer ${response.data.token}`;
                 return true;
            }
            return false
        });
        if (retry) {
            console.log('Reintentando.........');
            return axios.request(error.config);
        }
    }*/
    return Promise.reject(error);
});

Vue.prototype.$axios = axios;

// cssVars()
Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
Vue.use(Vue2Filters);
Vue.use(BootstrapVue);
sync(store, router);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {
        App
    },
    data: {
        minutos: 20,
        segundos: 0
    },
    methods: {
        iniciarCuenta() {
            setInterval(this.contarTiempo, 1000)
        },
        contarTiempo() {
            let getters = this.$store.getters;
            if (getters['authentication/isLoggedIn']) {
                if (this.segundos === 0 && this.minutos > 0) {
                    this.minutos -= 1;
                    this.segundos = 59;
                } else
                    this.segundos -= 1;

                this.$store.commit('setMinutos', this.minutos);
                this.$store.commit('setSegundos', this.segundos);
                this.tiempoTotal -= 1;
                this.$store.commit('setTiempo', this.tiempoTotal);
                if (this.minutos === 1 && this.segundos === 59) {
                    this.$store.commit('setMostrarAlertaTimeOut', true);
                }
                if (this.minutos === 0 && this.segundos === 0) {
                    //log out the user
                    this.refrescarContadorTiempo();
                    this.$store.dispatch('authentication/logout');
                }
            }
        },
        refrescarContadorTiempo() {
            this.minutos = 20;
            this.segundos = 0;
            this.$store.commit('setMostrarAlertaTimeOut', false);
        }
    },
    created: function () {
        window.addEventListener('click', this.refrescarContadorTiempo);
        window.addEventListener('scroll', this.refrescarContadorTiempo);
    },
    destroyed: function () {
        window.removeEventListener('click', this.refrescarContadorTiempo);
        window.removeEventListener('scroll', this.refrescarContadorTiempo);
    },
    beforeMount() {
        this.iniciarCuenta();
    }
})
